import { Route, Switch } from 'react-router-dom'

import useReduxSelector from 'hooks/useReduxSelector'

import HomePage from './HomePage'
import PrelaunchCalifornia from './prelaunch/california'

const PrelaunchRouter = () => {
  return (
    <Switch>
      <Route path="/california">
        <PrelaunchCalifornia />
      </Route>
    </Switch>
  )
}

const Home = () => {
  const marketActive = useReduxSelector(
    (state) => state?.home?.data?.currentMarket?.active,
  )
  const marketInactive = marketActive === false

  if (marketInactive) {
    return <PrelaunchRouter />
  }

  return <HomePage />
}

export default Home
